
// src/actions/likes.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const LIKE_DIARY = "LIKE_DIARY"
export const LIKE_DIARY_REQUESTED = "LIKE_DIARY_REQUESTED"
export const LIKE_DIARY_COMPLETED = "LIKE_DIARY_COMPLETED"
export const LIKE_DIARY_FAILED = "LIKE_DIARY_FAILED"

export function likeDiaryRequested() {
  return {
    type: LIKE_DIARY_REQUESTED
  }
}

export function likeDiary(diary_id, like_type) {
  return function(dispatch) {
    dispatch(likeDiaryRequested())
    return api.post(`/likes`, { diary_id, like_type })
        .then((results)=> {
          dispatch(likeDiaryCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(likeDiaryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function likeDiaryCompleted(results) {
  return {
    type: LIKE_DIARY_COMPLETED,
    results,
  }
}

export function likeDiaryFailed(error) {
  return {
    type: LIKE_DIARY_FAILED,
    error,
  }
}

export const LIKE_COMMENT = "LIKE_COMMENT"
export const LIKE_COMMENT_REQUESTED = "LIKE_COMMENT_REQUESTED"
export const LIKE_COMMENT_COMPLETED = "LIKE_COMMENT_COMPLETED"
export const LIKE_COMMENT_FAILED = "LIKE_COMMENT_FAILED"

export function likeCommentRequested() {
  return {
    type: LIKE_COMMENT_REQUESTED
  }
}

export function likeComment(comment_id, like_type) {
  return function(dispatch) {
    dispatch(likeCommentRequested())
    return api.post(`/likes`, { comment_id, like_type })
        .then((results)=> {
          dispatch(likeCommentCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(likeCommentFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function likeCommentCompleted(results) {
  return {
    type: LIKE_COMMENT_COMPLETED,
    results,
  }
}

export function likeCommentFailed(error) {
  return {
    type: LIKE_COMMENT_FAILED,
    error,
  }
}

export const DELETE_LIKE = "DELETE_LIKE"
export const DELETE_LIKE_REQUESTED = "DELETE_LIKE_REQUESTED"
export const DELETE_LIKE_COMPLETED = "DELETE_LIKE_COMPLETED"
export const DELETE_LIKE_FAILED = "DELETE_LIKE_FAILED"

export function deleteLikeRequested() {
  return {
    type: DELETE_LIKE_REQUESTED
  }
}

export function deleteLike(like_id) {
  return function(dispatch) {
    dispatch(deleteLikeRequested())
    return api.delete(`/likes/${like_id}`)
        .then((results)=> {
          dispatch(deleteLikeCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deleteLikeFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deleteLikeCompleted(results) {
  return {
    type: DELETE_LIKE_COMPLETED,
    results,
  }
}

export function deleteLikeFailed(error) {
  return {
    type: DELETE_LIKE_FAILED,
    error,
  }
}

export const FETCH_LIKE_CONFIG = "FETCH_LIKE_CONFIG"
export const FETCH_LIKE_CONFIG_REQUESTED = "FETCH_LIKE_CONFIG_REQUESTED"
export const FETCH_LIKE_CONFIG_COMPLETED = "FETCH_LIKE_CONFIG_COMPLETED"
export const FETCH_LIKE_CONFIG_FAILED = "FETCH_LIKE_CONFIG_FAILED"

export function fetchLikeConfigRequested() {
  return {
    type: FETCH_LIKE_CONFIG_REQUESTED
  }
}

export function fetchLikeConfig() {
  return function(dispatch) {
    dispatch(fetchLikeConfigRequested())
    return api.get(`/likes/config`)
        .then((results)=> {
          dispatch(fetchLikeConfigCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchLikeConfigFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchLikeConfigCompleted(results) {
  return {
    type: FETCH_LIKE_CONFIG_COMPLETED,
    results,
  }
}

export function fetchLikeConfigFailed(error) {
  return {
    type: FETCH_LIKE_CONFIG_FAILED,
    error,
  }
}



// WEBPACK FOOTER //
// ./src/actions/likes.js